webpackJsonp([22846268747618],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(72);
	
	var _helpers = __webpack_require__(43);
	
	var _newsItemModule = __webpack_require__(280);
	
	var _newsItemModule2 = _interopRequireDefault(_newsItemModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var thumbnails = (0, _helpers.importImages)(__webpack_require__(397));
	
	var NewsItem = function NewsItem(props) {
		return _react2.default.createElement(
			"div",
			{ className: props.className },
			_react2.default.createElement("div", {
				className: "col-12 col-md-5 col-lg-4 " + _newsItemModule2.default.featured_img,
				style: {
					backgroundImage: "url(https:" + props.featured_img.resolutions.src + ")"
				}
			}),
			_react2.default.createElement(
				"div",
				{ className: "col-12 col-md-7 col-lg-8 " + _newsItemModule2.default.post },
				_react2.default.createElement(
					_reactRouterDom.Link,
					{ to: props.category_url, className: _newsItemModule2.default.post_category },
					props.category
				),
				_react2.default.createElement(
					"h3",
					{ className: _newsItemModule2.default.post_title },
					props.url ? _react2.default.createElement(
						_reactRouterDom.Link,
						{ to: props.url },
						(0, _helpers.truncate)(props.title, 58, true)
					) : (0, _helpers.truncate)(props.title, 58, true)
				),
				_react2.default.createElement(
					"p",
					{ className: _newsItemModule2.default.post_excerpt },
					props.excerpt,
					props.url && _react2.default.createElement(
						_reactRouterDom.Link,
						{ to: props.url, style: { display: "block" } },
						"Read more \xBB"
					)
				),
				_react2.default.createElement(
					"span",
					{ className: _newsItemModule2.default.post_date },
					props.published
				)
			)
		);
	};
	
	exports.default = NewsItem;
	module.exports = exports["default"];

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"featured_img":"src-components-news-item----news-item-module---featured_img---3n98I","post":"src-components-news-item----news-item-module---post---Zsvc_","post_category":"src-components-news-item----news-item-module---post_category---3husl","post_title":"src-components-news-item----news-item-module---post_title---p_Y5k","post_excerpt":"src-components-news-item----news-item-module---post_excerpt---3i2tS","post_date":"src-components-news-item----news-item-module---post_date---urPI9"};

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ICEMR_image.cc673dde.jpg";

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ICEMR_image_th.ada1449a.jpg";

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Ivermectin_for_malaria_elimination_image.a71cc1d5.jpg";

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Ivermectin_for_malaria_elimination_image_th.22540183.jpg";

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MMV_award_image.c536589c.jpg";

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MMV_award_image_th.4cf749c4.jpg";

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/councilor_image.e0e6476a.jpg";

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/councilor_image_th.25282da0.jpg";

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"jumbo_h1":"src-styles----news-module---jumbo_h1---3mWEZ"};

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./ICEMR_image.jpg": 383,
		"./ICEMR_image_th.jpg": 384,
		"./Ivermectin_for_malaria_elimination_image.jpg": 385,
		"./Ivermectin_for_malaria_elimination_image_th.jpg": 386,
		"./MMV_award_image.jpg": 387,
		"./MMV_award_image_th.jpg": 388,
		"./councilor_image.jpg": 389,
		"./councilor_image_th.jpg": 390
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 397;


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _subNav = __webpack_require__(73);
	
	var _subNav2 = _interopRequireDefault(_subNav);
	
	var _SectionTitle = __webpack_require__(53);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _newsItem = __webpack_require__(241);
	
	var _newsItem2 = _interopRequireDefault(_newsItem);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _newsModule = __webpack_require__(285);
	
	var _newsModule2 = _interopRequireDefault(_newsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var renderItems = function renderItems() {
		var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		return array.map(function (item, i) {
			if (item.cat !== null) {
				return _react2.default.createElement(
					"div",
					{ key: "news-" + (i + 1), className: "col-12 card mb-3" },
					_react2.default.createElement(_newsItem2.default, {
						className: "row",
						category: item.cat || "Undefined",
						category_url: "/" + item.node_locale + "/news/cat/" + (item.cat || undefined),
						title: item.title,
						excerpt: item.content.content.excerpt,
						published: item.datePublished,
						featured_img: item.featuredImage,
						url: "/" + item.node_locale + "/news/" + item.slug
					})
				);
			}
			return null;
		});
	};
	
	var News = function (_React$Component) {
		_inherits(News, _React$Component);
	
		function News(props) {
			_classCallCheck(this, News);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.handleClick = function (category) {
				// this.loadPublications(year);
				_this.setState({ currentCat: category });
			};
	
			_this.state = {
				currentCat: "opinion",
	
				loadMore: true
			};
			return _this;
		}
	
		News.prototype.componentDidMount = function componentDidMount() {
			// const hashCategory = capitalizeFirstLetter(
			// 	this.props.location.hash.slice(1)
			// );
	
			// if (hashCategory) {
			// 	this.setState({
			// 		currentCat: capitalizeFirstLetter(
			// 			this.props.location.hash.slice(1)
			// 		)
			// 	});
			// } else {
			this.setState({ currentCat: this.props.pathContext.type });
			// }
		};
	
		News.prototype.render = function render() {
			var news = [];
			if (this.props.data.news) {
				news = this.props.data.news.edges.map(function (item) {
					return item.node;
				});
			}
	
			var pageSettings = this.props.data.pageSettings;
	
	
			var navList = [{
				label: "Latest",
				name: "latest",
				href: "/" + pageSettings.node_locale + "/news"
			}, {
				label: "News",
				name: "news",
				href: "/" + pageSettings.node_locale + "/news/cat/news"
			}, {
				label: "Opinions",
				name: "opinion",
				href: "/" + pageSettings.node_locale + "/news/cat/opinion"
			}, {
				label: "Resources",
				name: "resource",
				href: "/" + pageSettings.node_locale + "/news/cat/resource"
			}];
	
			var transition = this.props.transition;
	
			return _react2.default.createElement(
				_PageWrapper2.default,
				{ locale: pageSettings.node_locale, location: this.props.location, data: this.props.data.layout.edges[0].node },
				_react2.default.createElement(
					"main",
					{ role: "main", style: transition && transition.style },
					_react2.default.createElement(
						_Jumbotron2.default,
						{
							type: "jumbotron_b",
							bottomLine: true,
							className: "mb-0",
							textAlign: "text-center",
							contentAlign: "justify-content-md-center"
						},
						_react2.default.createElement(
							"h1",
							{ className: _newsModule2.default.jumbo_h1 },
							"News"
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "grey_bg" },
						_react2.default.createElement(
							"div",
							{
								className: "container",
								style: { transform: "translateY(-50%)" }
							},
							_react2.default.createElement(
								"div",
								{ className: "row justify-content-center" },
								_react2.default.createElement(
									"div",
									{ className: "col-10 col-sm-10 col-lg-10" },
									_react2.default.createElement(_subNav2.default, {
										active: this.state.currentCat,
										navList: navList,
										handleClick: function handleClick() {}
									})
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "container pt-lg-5 pb-5" },
							_react2.default.createElement(
								"div",
								{ className: "row" },
								news && news.length > 0 ? renderItems(news) : _react2.default.createElement(
									"div",
									{ className: "col-12 card mb-3 py-5 text-center" },
									_react2.default.createElement(
										"h2",
										null,
										"Coming soon!"
									),
									_react2.default.createElement("br", null),
									_react2.default.createElement(
										"h4",
										null,
										"We are still preparing the",
										" ",
										_react2.default.createElement(
											"span",
											{
												style: {
													textTransform: "lowercase"
												}
											},
											this.state.currentCat
										),
										". Come back soon!"
									)
								)
							)
						)
					)
				)
			);
		};
	
		return News;
	}(_react2.default.Component);
	
	exports.default = News;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-news-page-type-template-js-ca27623a60f816268ac2.js